import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { Site } from 'src/models/site';
import { makeStyles, Theme } from '@material-ui/core';

interface TimeDisplayProps {
  site: Site;
}

const TimeDisplay: React.FC<TimeDisplayProps> = ({ site }) => {
  const [localTime, setLocalTime] = useState<string>('');
  const [siteTime, setSiteTime] = useState<string>('Unknown');
  const classes = useStyles();

  useEffect(() => {
    const updateTimes = () => {
      const now = new Date();
      if (site && site.ianaTimeZone) {
        const siteTime = utcToZonedTime(now, site.ianaTimeZone);
        const siteTimeFormatted = format(siteTime, 'h:mm a z');
        setSiteTime(siteTimeFormatted);
      }
      const localTime = format(now, 'h:mm a z');
      setLocalTime(localTime);
    };

    updateTimes();
    const interval = setInterval(updateTimes, 1000);
    return () => clearInterval(interval);
  }, [site]);

  return (
    <div className={classes.container}>
      {false && (
        <div>
          <Typography variant="h3" className={classes.overline}>
            Time at site
          </Typography>
          <Typography variant="body2" className={classes.semibold}>
            {siteTime}
          </Typography>
        </div>
      )}
      <div>
        <Typography variant="h3" className={classes.overline}>
          My Time
        </Typography>
        <Typography variant="body2" className={classes.semibold}>
          {localTime}
        </Typography>
      </div>
    </div>
  );
};

const useStyles = makeStyles<Theme>((theme) => ({
  overline: {
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '120%',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    marginBottom: 4,
  },
  semibold: {
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '120%',
  },
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: '24px',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr 1fr',
    },
  },
}));

export default TimeDisplay;
